module.exports = __webpack_public_path__ + "img/Owens.790652f8.jpg";